"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "content-wrapper" };
const _hoisted_2 = { class: "flex-column flex-gap" };
const _hoisted_3 = { class: "input-group column p-0" };
const _hoisted_4 = { class: "oplus-form-checkbox" };
const _hoisted_5 = { class: "input-group column p-0" };
const _hoisted_6 = { class: "input-group column p-0" };
const _hoisted_7 = { class: "input-group column p-0" };
const _hoisted_8 = { class: "input-group column p-0" };
const _hoisted_9 = { class: "section-color-box" };
const _hoisted_10 = { class: "flex-column p-0" };
const _hoisted_11 = { class: "input-group mt-2" };
const vue_3 = require("vue");
const ColorBox_vue_1 = __importDefault(require("../../vue/ColorBox.vue"));
const Modal_vue_1 = __importDefault(require("../../vue/Modal.vue"));
const models_1 = require("../../js/models");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SectionModal',
    props: {
        section: {
            type: Object,
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["close-modal", "section-submit", "section-delete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const isFromTimeValid = (0, vue_3.ref)(true);
        const isToTimeValid = (0, vue_3.ref)(true);
        const isFormValid = (0, vue_3.computed)(() => {
            return isFromTimeValid.value && isToTimeValid.value;
        });
        const computedSubmitText = (0, vue_3.computed)(() => {
            return props.section ? '保存' : '登録';
        });
        const data = (0, vue_3.ref)({
            id: props.section?.id || 0,
            name: props.section?.name || "",
            purpose: props.section?.purpose || "",
            from: props.section?.from || "",
            to: props.section?.to || "",
            isRest: props.section?.isRest || false,
            color: props.section?.color || models_1.OPLUS_COLOR_PALETTE.DEFAULT,
            memo: props.section?.memo || "",
            roleId: props.section?.roleId || 0,
        });
        function closeSectionModal() {
            emits('close-modal');
        }
        function submitSection() {
            isFromTimeValid.value = true;
            isToTimeValid.value = true;
            if (!data.value.from) {
                isFromTimeValid.value = false;
            }
            if (!data.value.to) {
                isToTimeValid.value = false;
            }
            if (!isFormValid.value) {
                return;
            }
            emits('section-submit', data.value);
        }
        function deleteSection() {
            emits('section-delete', data.value.id);
        }
        function handleColorSelect(colorStr) {
            data.value.color = colorStr;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                onCloseModal: closeSectionModal,
                "has-title-divider": true,
                "has-footer-divider": false
            }, {
                "header-title": (0, vue_2.withCtx)(() => [...(_cache[7] || (_cache[7] = [
                        (0, vue_2.createElementVNode)("span", { class: "header-text" }, " セクション ", -1 /* CACHED */)
                    ]))]),
                content: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                (0, vue_2.createElementVNode)("label", _hoisted_4, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((data.value.isRest) = $event)),
                                        type: "checkbox",
                                        id: "section-modal-rest"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelCheckbox, data.value.isRest]
                                    ]),
                                    _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                    _cache[9] || (_cache[9] = (0, vue_2.createTextVNode)(" 休憩 ", -1 /* CACHED */))
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((data.value.purpose) = $event)),
                                    class: "form-input",
                                    type: "text",
                                    placeholder: "任意 例：レジ、清掃"
                                }, null, 512 /* NEED_PATCH */), [
                                    [vue_2.vModelText, data.value.purpose]
                                ]),
                                _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("span", { class: "input-group-addon" }, "ラベル", -1 /* CACHED */))
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((data.value.from) = $event)),
                                    class: (0, vue_2.normalizeClass)(["form-input", { 'is-error': !isFromTimeValid.value }]),
                                    type: "text",
                                    placeholder: "10, 10:00, 1000"
                                }, null, 2 /* CLASS */), [
                                    [vue_2.vModelText, data.value.from]
                                ]),
                                _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("span", { class: "input-group-addon" }, "から", -1 /* CACHED */))
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((data.value.to) = $event)),
                                    class: (0, vue_2.normalizeClass)(["form-input", { 'is-error': !isToTimeValid.value }]),
                                    type: "text",
                                    placeholder: "18, 18:00, 1800"
                                }, null, 2 /* CLASS */), [
                                    [vue_2.vModelText, data.value.to]
                                ]),
                                _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("span", { class: "input-group-addon" }, "まで", -1 /* CACHED */))
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    (0, vue_2.createVNode)(ColorBox_vue_1.default, {
                                        "is-visible": true,
                                        "selected-color": data.value.color,
                                        "use-for-modal": true,
                                        onColorSelect: handleColorSelect
                                    }, null, 8 /* PROPS */, ["selected-color"])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_10, [
                                _cache[13] || (_cache[13] = (0, vue_2.createElementVNode)("div", {
                                    class: "divider text-center",
                                    "data-content": "メモ"
                                }, null, -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("textarea", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((data.value.memo) = $event)),
                                        class: "form-input font-sm",
                                        rows: "4",
                                        placeholder: "メモ"
                                    }, null, 512 /* NEED_PATCH */), [
                                        [vue_2.vModelText, data.value.memo]
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                "footer-btn": (0, vue_2.withCtx)(() => [
                    (__props.section)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 0,
                            id: "section-delete-btn",
                            class: (0, vue_2.normalizeClass)(["btn text-error float-left", { 'loading': __props.isLoading }]),
                            onClick: _cache[5] || (_cache[5] = ($event) => (deleteSection()))
                        }, [...(_cache[14] || (_cache[14] = [
                                (0, vue_2.createElementVNode)("i", { class: "icon icon-delete" }, null, -1 /* CACHED */)
                            ]))], 2 /* CLASS */))
                        : (0, vue_2.createCommentVNode)("v-if", true),
                    (0, vue_2.createElementVNode)("button", {
                        id: "section-submit",
                        class: (0, vue_2.normalizeClass)(["oplus-modal-btn oplus-alt-confirm-btn", { 'loading': __props.isLoading }]),
                        onClick: _cache[6] || (_cache[6] = ($event) => { submitSection(); })
                    }, (0, vue_2.toDisplayString)(computedSubmitText.value), 3 /* TEXT, CLASS */)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
